import React, { Component } from 'react';
import { Menu } from 'antd';

const { SubMenu } = Menu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: this.props.selectKey,
        };
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render() {
        const { curRole, isHospitalDirector, outInvHaveMajorEvent } = sessionStorage;
        const isCRC = curRole == 'CRC';
        const isHRRC = curRole == 'HRRC';
        const isCSA = curRole == 'CSA';
        const isCSAL = curRole == 'CSAL';
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[this.state.current]}
                    mode="inline"
                >
                <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe62f;</i><span>质量管理</span></span>}>
                    {
                        outInvHaveMajorEvent === 'true' &&
                        <Menu.Item key="importantEvent">
                            <a href="#/qualityManagement/importantEvent">重大事件</a>
                        </Menu.Item>
                    }
                    {
                        (!isCRC && !isCSA && !isCSAL) &&
                        <Menu.Item key="complaintRegistrationForm">
                            <a href="#/qualityManagement/complaintRegistrationForm">投诉登记表</a>
                        </Menu.Item>
                    }
                    {
                        (!isHRRC || isHospitalDirector) && <Menu.Item key="nationalVerification">
                        <a href="#/qualityManagement/nationalVerification">国家核查汇总</a>
                    </Menu.Item>
                    }   
                    {
                        !isHRRC && <Menu.Item key="ImportantMilestone">
                        <a href="#/qualityManagement/ImportantMilestone">重要里程碑和上市登记</a>
                    </Menu.Item>
                    }
                </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default SideNav;


// WEBPACK FOOTER //
// ./src/components/qualityManagement/SideNav.js